import api from "./api";

// --- Types ---

export interface ReportSection {
  key: string;
  displayTitle: string;
  order: number;
  required: boolean;
  enabled: boolean;
}

export interface PatientInfoField {
  key: string;
  label: string;
  enabled: boolean;
  locked: boolean;
}

export interface MdtReportStructure {
  id: string;
  reportTitle: string;
  reportIdPrefix: string;
  sections: ReportSection[];
  patientInfoFields: PatientInfoField[];
  updatedBy?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface UpdateStructurePayload {
  reportTitle?: string;
  reportIdPrefix?: string;
  sections?: ReportSection[];
  patientInfoFields?: PatientInfoField[];
}

const BASE = "/api/super-admin/mdt-report-structure";

export const getStructure = async (): Promise<MdtReportStructure> => {
  const { data } = await api.get(BASE);
  return data.data;
};

export const updateStructure = async (payload: UpdateStructurePayload): Promise<MdtReportStructure> => {
  const { data } = await api.put(BASE, payload);
  return data.data;
};